import React, {createContext} from "react";
import { reducer } from "./reducer";
import { useReducer } from "react";
import { useContext } from "react";
import { useEffect } from "react";

const AppContext = React.createContext();

const API = "https://thapareactapi.up.railway.app";
const intialState = {
    name: "",
    image: "",
    services: [],
} ;



const AppProvider = ({children}) =>{
    const [state, dispatch] = useReducer(reducer, intialState);
    const updateHomePage = () =>{
        return dispatch({
            type: "HOME_UPDATE",
            payload:{
                name: "ColgLin",
                photu: "./photos/hero.jpg",
                tdata: "This is Us",
            },
        });
    };
    const updateAboutPage = () =>{
        return dispatch({
            type: "ABOUT_UPDATE",
            payload:{
                name: "About ColgLin",
                photu: "./photos/about.png",
                tdata: "This is Us",
            },
        });
    };
    
    const getServices = async (url) =>{
        try{
            const res = await fetch(url);
            const data = await res.json();
            dispatch({type:"GET_SERVICES", payload: data});

        }catch(error){
            console.log(error);
        }
    }
    
    useEffect(()=>{
       getServices(API); 
    }, []);

    return (<AppContext.Provider value={{...state, updateHomePage, updateAboutPage}}>{children}</AppContext.Provider>);
};

const useGlobalContext =() =>{
     return useContext(AppContext);
}
 
export {AppContext, AppProvider, useGlobalContext};